import React from 'react';
import ProductDetailPanel from '../../common/ProductDetailPanel';
import {
  PRODUCT_DETAIL_PAGE_PANEL_NAME,
  PRODUCT_STATUS_TEXT,
} from '../../../../constants/service/app/productConstants';
import { compareProductVersion } from '../../../../lib/utils';
import './ProductDetailStatus.scss';
import BaseForm from '../../../../components/form/BaseForm';

const ProductDetailStatus = (props) => {
  const { initialValue, isCompare, comparisonData, ...res } = props;
  const { status } = initialValue;

  return (
    <ProductDetailPanel
      name={PRODUCT_DETAIL_PAGE_PANEL_NAME.PRO_STATUS_AND_BRAND_INFO}
      className="product-detail-status"
      title="상품 상태"
      isCompare={isCompare}
      {...res}
    >
      <div className="panel-body">
        <BaseForm
          label="상품 상태"
          className={isCompare && compareProductVersion(status, comparisonData.status)}
          name="status"
          content={PRODUCT_STATUS_TEXT[status]}
        />
      </div>
    </ProductDetailPanel>
  );
};

export default ProductDetailStatus;
